import { openAuthedFile } from "@/lib/openFile";

// Gleiche Regeln wie backend/produktion.py: offen = Menge − (in Produktion + fertig + versendet + entfällt)
const KEYS = ["in_produktion", "fertig", "versendet", "entfaellt"];
export const isPart = (p) => p.typ !== "versand";

export function counts(p) {
  const pr = p.produktion || {};
  const c = Object.fromEntries(KEYS.map((k) => [k, Math.max(Number(pr[k]) || 0, 0)]));
  c.offen = Math.max((Number(p.menge) || 0) - KEYS.reduce((s, k) => s + c[k], 0), 0);
  c.unversendet = c.offen + c.in_produktion + c.fertig;
  return c;
}

export function summary(positions = []) {
  const t = { menge: 0, offen: 0, in_produktion: 0, fertig: 0, versendet: 0, entfaellt: 0 };
  positions.filter(isPart).forEach((p) => {
    const c = counts(p);
    t.menge += Number(p.menge) || 0;
    ["offen", "in_produktion", "fertig", "versendet", "entfaellt"].forEach((k) => { t[k] += c[k]; });
  });
  return t;
}

export const hasProduction = (positions = []) => positions.some((p) => isPart(p) && p.produktion);

export function bezeichnung(p) {
  const first = String(p.beschreibung || "").split("\n")[0].trim();
  return String(p.name || "").trim() || first || "Position";
}

export const datei = (p) => p.kalk?.file_name || "";

export const VERSAND_STATUS_LABEL = { teilversendet: "Teilversendet", versendet: "Versendet" };

// PDF (mit Anmeldung) in neuem Tab öffnen – siehe lib/openFile.js (Fenster wird synchron geöffnet)
export function openPdf(path, filename = "dokument.pdf") {
  return openAuthedFile(path, filename);
}
